import React from 'react';
import Footer from '../../../Shared/Footer';
import Header from '../../../Shared/Header';
import AllProducts from './AllProducts';

const Explore = () => {
    return (

        //all products page
        <div>
            <div>
                <Header></Header>
            </div>
            <div>
                <AllProducts></AllProducts>
            </div>
            <Footer></Footer>
        </div>

    );
};

export default Explore;